import React, { useEffect, useRef, useState } from 'react'
import { ServiceDoropdownIcon } from '../../../components/common/SvgIcon';

const ServiceDropdown = ({ value, onChange, services, placeholder = 'Service' }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  const filtered = services.filter((s) =>
    s.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between !border !border-[#E4E4E7] rounded-xl px-3 py-2 text-sm bg-white text-[#17171C] hover:!border-[#17171C] focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none transition cursor-pointer"
      >
        <span className={value ? 'text-[#17171C]' : 'text-[#9CA3AF]'}>
          {value || placeholder}
        </span>
        <ServiceDoropdownIcon open={open} />
      </button>

      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-[#E4E4E7] rounded-lg shadow-lg overflow-hidden">
          <div className="p-2 border-b border-[#E4E4E7]">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              className="w-full text-sm px-2 py-1 border border-[#E4E4E7] rounded outline-none focus:border-[#7C3BED]"
              autoFocus
            />
          </div>
          <div className="max-h-40 overflow-y-auto">
            {filtered.length === 0 ? (
              <p className="text-sm text-[#6F6F7B] px-3 py-2">No results</p>
            ) : (
              filtered.map((s) => (
                <button
                  key={s}
                  type="button"
                  onClick={() => { onChange(s); setOpen(false); setSearch(''); }}
                  className={[
                    'w-full text-left px-3 py-2 text-sm hover:bg-[#F4F4F5] transition',
                    s === value ? 'text-[#7C3BED] font-medium bg-purple-50' : 'text-[#17171C]',
                  ].join(' ')}
                >
                  {s}
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceDropdown
